import { MenuButton } from 'src/app/shared/model/menu-button';
import { UserSettingsService } from '../settings/service/user-settings.service';

// Definicja kafelków konfiguracji pojazdów. Wydzielona z komponentu, bo korzysta z niej także mapa aplikacji.
export function buildVehiclesConfigMenu(settings: UserSettingsService): MenuButton[] {
  return [
    {
      text: 'vehicleManagement',
      iconName: 'bus',
      routerLink: 'vehicles',
      condition: settings.shouldShowVehicleManagement()
    },
    {
      text: 'passengerResetStop',
      iconName: 'bus_stop_on',
      routerLink: 'line-direction-counters-resets',
      condition: settings.isPassengerResetStopsEnabled()
    }
  ];
}
